import api from '../../lib/api';

export interface VersionReportBody {
  deviceId: string;
  runtimeVersion: string;
  platform: string;
  appVersion: string;
  /** EAS channel the running build was published from (e.g. 'production'). */
  channel?: string | null;
  easBuildId?: string | null;
  updateGroupId?: string | null;
}

/**
 * Fire-and-forget POST to the version-reports public endpoint.
 * Caller is responsible for catching all errors.
 */
export const reportVersion = (body: VersionReportBody): Promise<unknown> =>
  api.post('/client-reports', body);
